import { schema } from 'normalizr';

// eslint-disable-next-line import/prefer-default-export
export const visitNoteTypeSchema = new schema.Entity('visitNoteTypes');
